/**
 * Checks if the current environment is a development environment.
 * Returns true if NODE_ENV is 'development' or 'test'.
 */

export const isDev = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
